import { Swiper, Navigation, Pagination, Thumbs, Controller } from 'swiper';
import elementExists from "../core/utils/element-exists"

const SingleRecipe = function () {
    let stepsHeaderMobile = document.querySelectorAll('.steps-mobile h3');
    let stepsMobile = document.querySelectorAll('.steps-mobile p');

    let stepsHeaderDesktop = document.querySelectorAll('.steps-desktop h3');
    let stepsDesktop = document.querySelectorAll('.steps-desktop p');

    if( elementExists( stepsHeaderMobile) && elementExists( stepsMobile , true )){
        function addNumbers (header, steps) {
            if ( (header.length > 0) ) {
                let i = 1;
                header.forEach(step => {
                    let count = document.createElement("span");
                    count.innerHTML = "0" + i;
                    step.insertAdjacentElement('afterbegin', count);
                    i++;
                });
            } else {
                let i = 1;
                steps.forEach(step => {
                    let count = document.createElement("span");
                    if( i < 10 ){
                        count.innerHTML = "0" + i;
                    }else{
                        count.innerHTML = i;
                    }
                    step.insertAdjacentElement('afterbegin', count);
                    i++;
                });
            }
        }

        addNumbers(stepsHeaderMobile, stepsMobile);
        addNumbers(stepsHeaderDesktop, stepsDesktop);
    }

    let ingredients = document.querySelectorAll('.single-recipe__ingredients li');
    if ( elementExists(ingredients) ) {
        ingredients.forEach(item => {
            let arrow = document.createElement("span");
            arrow.classList.add( 'arrow');
            item.insertAdjacentElement('afterbegin', arrow);
        });
    }

}
  

export default SingleRecipe;